module.exports = __webpack_public_path__ + "img/bitcoin.f9943961.png";